export default __webpack_public_path__ + "static/media/dog.39a14984.png";